import { PrescriptionStatus } from '../types/data';
import { DateValueType } from 'react-tailwindcss-datepicker';

export const getPrescriptionStatusId = (status: PrescriptionStatus, statusFilter: any[]): number => {
  const statusItem = statusFilter?.find((item) => item.Title === status);
  const id = statusItem?.id || statusItem?.ID || 1; // по умолчанию "В процессе" (id=1)
  return id;
};

export const determinePrescriptionStatus = (deadlineDate: Date | null, actionStatus?: string): PrescriptionStatus => {
  //! Если все действия закрыты или отменены - предписание выполнено
  if (actionStatus === 'Закрыто') {
    return 'Выполнено';
  }

  if (!deadlineDate) return 'В процессе';

  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);
  const deadline = new Date(deadlineDate);
  deadline.setHours(0, 0, 0, 0);

  //! Если срок просрочен - предписание просрочено
  if (currentDate > deadline) {
    return 'Просрочено';
  }

  return 'В процессе';
};

export const getFormattedDeadlineDate = (deadlineDate: DateValueType, initialValues?: any): Date | null => {
  if (deadlineDate?.startDate) {
    return new Date(deadlineDate.startDate);
  }

  if (initialValues?.deadlineExecutionOrder) {
    return new Date(initialValues.deadlineExecutionOrder);
  }

  return null;
};

export const formatEmptyPrescriptionBody = (prescriptionStatus: string, actionStatus: string, defaultResponsible: any, prescriptionStatusFilter: any[], actionStatusFilter: any[]) => {
  const prescriptionStatusId = getPrescriptionStatusId(prescriptionStatus as PrescriptionStatus, prescriptionStatusFilter);
  return {
    // Title: `prescriptionGos`,
    PrescriptionNumber: '-',
    Direction: null,
    // Responsible: defaultResponsible.id,
    ResponsibleEmail: defaultResponsible.email,
    GOSLocation: null,
    DateVerification: null,
    DeadlineExecutionOrder: null,
    AgencyInspection: '-',
    ScopeVerification: '-',
    TypeVerification: '-',
    FieldActivity: '-',
    DepartmentsAudit: '-',
    NameRegulatoryDocument: '-',
    // InterestedParties: [],
    InterestedPartiesEmails: [],
    AmountFine: '-',
    FundsEliminationComments: '-',
    Comments: '-',
    DateUpdate: null,
    FrequencyRepeatedNotifications: null,
    PeriodicNotificationUpdateDate: null,
    PrescriptionStatus: prescriptionStatusId,
  };
};